import Link from "@components/core/Link";
import ProductImage from "@components/core/ProductImage";
import ProductDiscountSticker from "@components/views/Product/Shared/ProductDiscountSticker";

function CartImageLink({ product }) {
  return (
    <Link href={`/products/${product.slug}?context=sales`}>
      <div className="sales-cart-image-container">
        <ProductImage
          src={product.main_picture_url || ""}
          alt={product.name}
          sizes="128px"
        />

        <ProductDiscountSticker
          product={product}
          context="sales"
          className="bottomed"
        />
      </div>
    </Link>
  );
}

export default CartImageLink;
